export default theme => ({
  root: {},
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formMonitor: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '30vw'
  },
  porletContentExt: {
    flexGrow: 1,
    padding: theme.spacing(0)
  },
  porletHeaderExt: {
    backgroundColor: 'Grey',
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  },
  customStylesPortletFooter: {
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit'
  },
  group: {
    flexGrow: 1,
    padding: theme.spacing(1)
  },
  groupLabel: {
    paddingLeft: theme.spacing(2)
  },
  subMenu: {
     backgroundColor: '#525252',
  },
  field: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
		width: '100%',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  textFieldMonitor: {
		width: '100%',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  textFieldSLA: {
    width: '100%',
  },
  textFieldSLALeft: {
    width: '0%',
    marginLeft: theme.spacing(5),
		marginBottom: theme.spacing(2)
  },
  portletFooter: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  formControl: {
    //margin: theme.spacing.unit * 2,
    minWidth: 120,
    width: '100%',
  },
  textFieldSelect: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 15,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
  },
  snackContent: {
    backgroundColor: theme.palette.error.dark,
  },
  snackContentOk: {
    backgroundColor: theme.palette.success.main,
  },
  popover:{
    width:"64%",
    //marginLeft:"250px"
  },
  popoverPorlet:{
      backgroundColor: "grey",
  },
  textColorPopover:{
      color:"white"
  },
  inputRoot: {
    '&$disabled': {
      color:'grey'
    },
  },
  disabled: {},
  labelRoot: {
    '&$disabled': {
      color:'grey'
    },
  },
  labelFocused: {},
  typography: {
    flexGrow: 1,
    padding: theme.spacing(1)
  },
});
